module.exports = __webpack_public_path__ + "img/10.e57a69cf.png";